// Excel-like inline rename for a single field. The <input> looks like plain
// text until focused; Enter or blur saves via a PATCH (JSON), Esc cancels.
//
// Markup:
//   <div data-controller="inline-rename"
//        data-inline-rename-url-value="<%= rename_path %>"
//        data-inline-rename-original-value="<%= current_name %>">
//     <input data-inline-rename-target="input"
//            data-action="blur->inline-rename#save keydown->inline-rename#keydown">
//     <span data-inline-rename-target="status"></span>
//   </div>
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, original: String }
  static targets = ["input", "status"]

  save() {
    const value = this.inputTarget.value.trim()
    if (value === this.originalValue) return
    this.flash("saving")

    fetch(this.urlValue, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": this.token()
      },
      body: JSON.stringify({ name: value })
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((data) => {
        this.originalValue = data.name
        this.inputTarget.value = data.name
        this.flash("saved")
      })
      .catch(() => {
        this.inputTarget.value = this.originalValue
        this.flash("error")
      })
  }

  keydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.inputTarget.blur() // triggers save via the blur action
    } else if (event.key === "Escape") {
      event.preventDefault()
      this.inputTarget.value = this.originalValue
      this.inputTarget.blur()
    }
  }

  token() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }

  flash(state) {
    if (!this.hasStatusTarget) return
    const marks = { saving: "…", saved: "✓", error: "✕" }
    this.statusTarget.textContent = marks[state] || ""
    this.statusTarget.style.color =
      state === "error" ? "#dc3545" : state === "saved" ? "#198754" : "#6c757d"
    if (state === "saved") {
      setTimeout(() => {
        if (this.hasStatusTarget) this.statusTarget.textContent = ""
      }, 1500)
    }
  }
}
